import { Tag } from '@zillow/constellation-10';

const TYPE_TO_TONE = {
  info: 'info',
  neutral: 'gray',
  success: 'success',
  warn: 'warning',
  caution: 'warning',
  in_progress: 'aqua',
} as const;

type Props = {
  message: string;
  type: 'info' | 'neutral' | 'success' | 'warn' | 'in_progress' | 'caution';
  size?: 'sm' | 'md';
};

const ConnectedStatus = ({ message, type, size = 'md' }: Props) => {
  const tone = TYPE_TO_TONE[type] || TYPE_TO_TONE.neutral;

  return (
    <Tag tone={tone} data-test="connected-status" size={size} title={message}>
      {message}
    </Tag>
  );
};

export default ConnectedStatus;
